import { api } from '@/config/api';

export interface AuthUser { userUid: string; companyUid: string | null; role: 'super_admin' | 'company_admin' | 'company_user'; }
export interface AuthResponse { token: string; user: AuthUser; }

export const authService = {
  loginWithPassword: async (email: string, password: string): Promise<AuthResponse> =>
    (await api.post('/auth/login', { email, password })).data,
  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await api.post('/auth/change-password', { currentPassword, newPassword });
  },
};
